import styled from "styled-components";

import { Tooltip } from "uikit";

export const Container = styled.div``;

export const StyledTooltip = styled(Tooltip)``;
